module.exports = __webpack_public_path__ + "static/img/labmacambira.cc6d0f9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/thumbnails/projects/labmacambira.png
// module id = fAbB
// module chunks = 0